export default {
  clicked: 'clickedButton_printReport',
}
